import { useEffect, useRef, useState } from "react";
import MenuButton from "./MenuButton";
import { useDispatch, useSelector } from "react-redux";
import ApiHelper from "../../../Helpers/ApiHelper";
import IconSvg from "../../SharedComponents/IconSvg";
import { SetScreenSizeCssClass, SetSelectedPage, SetSelectedPageWithoutUrl } from "../Store";
import { folderEnum } from "../../../Helpers/EnumHelper";
import HamburgerMenuIcon from "./HamburgerMenuIcon";

export default function AppMenu() {
  const dispatch = useDispatch();
  const selectedPage = useSelector((state) => state.appMenu.selectedPage);
  const pagesArray = useSelector((state) => state.appMenu.pages);
  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);
  const user = useSelector((state) => state.auth.user);
  const companyLogo = user.companyUser?.company?.logoPath;
  const companyIcon = user.companyUser?.company?.iconPath;

  const [isMouseHovering, setIsMouseHovering] = useState(undefined);
  const [isPinned, setIsPinned] = useState(windowSizeCssClass !== "small-screen");
  const leaveTimer = useRef(null);
  const hoverTimer = useRef(null);
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    if (!windowSizeCssClass.includes("mobile-screen")) {
      if (isMouseHovering) {
        dispatch(SetScreenSizeCssClass("large-screen"));
      } else {
        dispatch(SetScreenSizeCssClass("small-screen"));
      }
    }
  }, [isMouseHovering, dispatch]);

  useEffect(() => {
    if (windowSizeCssClass === "small-screen") {
      setIsPinned(false);
    }
  }, [isPinned, windowSizeCssClass]);

  useEffect(() => {
    let landingPageUrl = "";
    if (user.userRole === "User") landingPageUrl = "/userdash";
    if (user.userRole === "Admin") landingPageUrl = "/dash";
    if (user.userRole === "SuperAdmin") landingPageUrl = "/sdash";
    dispatch(SetSelectedPageWithoutUrl({ url: landingPageUrl }));
  }, [user.userRole, dispatch]);

  const HandleSideMenuButtonClick = (page) => {
    dispatch(SetSelectedPage({ url: page.url }));
    if (windowSizeCssClass === "mobile-screen extended") {
      dispatch(SetScreenSizeCssClass("mobile-screen collapsed"));
    }
  };

  return (
    <>
      <div
        className={`side-bar ${windowSizeCssClass} position-relative d-flex flex-column animate__animated   animate__fadeInLeft`}
        style={{ zIndex: windowSizeCssClass === "mobile-screen extended" ? 2000 : "auto" }}
        onMouseEnter={() => {
          if (isPinned) return;
          clearTimeout(leaveTimer.current);
          hoverTimer.current = setTimeout(() => setIsMouseHovering(true), 100);
        }}
        onMouseLeave={() => {
          if (isPinned) return;
          clearTimeout(hoverTimer.current);
          leaveTimer.current = setTimeout(() => setIsMouseHovering(false), 1000);
        }}
      >
        {/* Collapse/Expand Button */}
        {!windowSizeCssClass.includes("mobile-screen") && (
          <div
            className="position-absolute text-color-gray-dark z-1 translate-middle-x translate-middle-y "
            style={{ top: "110px", right: "10px" }}
          >
            {windowSizeCssClass === "large-screen" && (
              <div
                style={{ height: "30px", width: "30px" }}
                className="flex-center rounded-circle hover-bg-darken"
                onClick={() => {
                  setIsPinned((prev) => !prev);
                  clearTimeout(hoverTimer.current);
                }}
              >
                {isPinned ? (
                  <IconSvg icon={"pin-filled"} width={20} height={20} fill={"#8b8c89"} />
                ) : (
                  <IconSvg icon={"pin-empty"} width={20} height={20} fill={"#8b8c89"} />
                )}
              </div>
            )}
          </div>
        )}

        {/* Mobile Close Button */}
        {windowSizeCssClass === "mobile-screen extended" && (
          <div className="position-absolute text-color-gray-dark z-1 translate-middle-x" style={{ top: 20, left: 55 }}>
            <div
              style={{ height: 50, width: 50, border: "2px solid #efefef" }}
              className="flex-center rounded-circle hover-bg-darken"
              onClick={() => {
                dispatch(SetScreenSizeCssClass("mobile-screen collapsed"));
              }}
            >
              <HamburgerMenuIcon isOpen={true} />
            </div>
          </div>
        )}

        {/* Sidebar Menu Content */}
        <div className={`side-bar-menu ${windowSizeCssClass}`}>
          <div className={`side-bar-company-icon ${windowSizeCssClass} justify-content-center`}>
            {companyIcon && (
              <img
                style={{ maxWidth: "60px", maxHeight: "60px", width: "auto", height: "auto", objectFit: "contain" }}
                src={ApiHelper.cloudFrontURL + folderEnum.logo + companyIcon}
                alt="Company Icon"
              />
            )}
          </div>
          <div className={`side-bar-company-logo ${windowSizeCssClass} justify-content-center`}>
            {companyLogo && (
              <img
                src={ApiHelper.cloudFrontURL + folderEnum.logo + companyLogo}
                alt="Company Logo"
                style={{ maxWidth: "200px", maxHeight: "200px", width: "auto", height: "auto", objectFit: "contain" }}
              />
            )}
          </div>

          <div>
            {pagesArray.map((page, i) =>
              page.userRole === user.userRole ? (
                <MenuButton
                  key={i + "page"}
                  page={page}
                  selected={selectedPage}
                  HandleSideMenuButtonClick={HandleSideMenuButtonClick}
                />
              ) : null
            )}
          </div>
        </div>
      </div>
    </>
  );
}
